export function fmtUSD(n, opts = {}) {
  if (n === null || n === undefined) return "$0";
  const { decimals = 0 } = opts;
  return "$" + Number(n).toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function fmtUSDprecise(n) {
  const num = Number(n);
  if (n === null || n === undefined || isNaN(num)) return "$0.00";
  // micro-amounts (memecoin math): keep 3 significant digits instead of $0.00
  if (num > 0 && num < 0.01) return "$" + Number(num.toPrecision(3)).toString();
  return "$" + num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function fmtNum(n) {
  if (n === null || n === undefined) return "0";
  return Number(n).toLocaleString("en-US");
}

export function fmtToken(n) {
  const num = Number(n);
  if (num >= 1) return num.toLocaleString("en-US", { maximumFractionDigits: 2 });
  return num.toLocaleString("en-US", { maximumFractionDigits: 8 });
}

// Price formatter that keeps significant digits for sub-cent (memecoin) prices.
export function fmtPrice(n) {
  const num = Number(n);
  if (!num) return "$0.00";
  if (num >= 1) return "$" + num.toLocaleString("en-US", { maximumFractionDigits: 2 });
  if (num >= 0.01) return "$" + num.toFixed(4);
  return "$" + Number(num.toPrecision(3)).toString();
}

export function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - then) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export const CHAIN_LABELS = {
  ethereum: "Ethereum",
  base: "Base",
  arbitrum: "Arbitrum",
  optimism: "Optimism",
  bnb: "BNB Chain",
  polygon: "Polygon",
  avalanche: "Avalanche",
  solana: "Solana",
  bitcoin: "Bitcoin",
  dogecoin: "Dogecoin",
  tron: "Tron",
  hyperliquid: "Hyperliquid",
  robinhood: "Robinhood Chain",
};

export const EXPLORERS = {
  ethereum: "https://etherscan.io/tx/",
  base: "https://basescan.org/tx/",
  arbitrum: "https://arbiscan.io/tx/",
  optimism: "https://optimistic.etherscan.io/tx/",
  bnb: "https://bscscan.com/tx/",
  polygon: "https://polygonscan.com/tx/",
  avalanche: "https://snowtrace.io/tx/",
  hyperliquid: "https://hyperevmscan.io/tx/",
  robinhood: "https://robinhoodchain.blockscout.com/tx/",
  solana: "https://solscan.io/tx/",
  bitcoin: "https://mempool.space/tx/",
  dogecoin: "https://blockchair.com/dogecoin/transaction/",
  tron: "https://tronscan.org/#/transaction/",
};

export function explorerTx(chain, hash) {
  const base = EXPLORERS[chain] || EXPLORERS.ethereum;
  return base + hash;
}

export const ADDRESS_EXPLORERS = {
  ethereum: "https://etherscan.io/address/",
  base: "https://basescan.org/address/",
  arbitrum: "https://arbiscan.io/address/",
  optimism: "https://optimistic.etherscan.io/address/",
  bnb: "https://bscscan.com/address/",
  polygon: "https://polygonscan.com/address/",
  avalanche: "https://snowtrace.io/address/",
  hyperliquid: "https://hyperevmscan.io/address/",
  robinhood: "https://robinhoodchain.blockscout.com/address/",
  solana: "https://solscan.io/account/",
};

export function explorerAddress(chain, address) {
  if (!address) return null;
  const base = ADDRESS_EXPLORERS[chain];
  return base ? base + address : null;
}

export function shortAddress(addr) {
  if (!addr || typeof addr !== "string") return "";
  if (addr.length < 12) return addr;
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

// entity label helpers
export const entityLabel = (e) =>
  e.category === "tokens"
    ? (e.ticker || e.name || e.slug || "?")
    : ("@" + (e.handle || e.slug || "?"));
export const entityName = (e) =>
  e.category === "tokens"
    ? (e.name || e.ticker || e.slug || "")
    : (e.display_name || e.handle || "");

/** Resolve self-hosted `/api/avatars/...` logos against the API origin. */
export function publicAssetUrl(url) {
  if (!url || typeof url !== "string") return url;
  if (!url.startsWith("/api/")) return url;
  const backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  if (backend) return `${backend}${url}`;
  return url;
}

export const entityImage = (e) =>
  publicAssetUrl(e.category === "tokens" ? e.logo : e.avatar);
export const entityPath = (e) =>
  e.category === "tokens" ? `/token/${e.slug}` : `/caller/${e.slug}`;
